import gql from 'graphql-tag';

export default gql`
mutation CreatePaidLease(
        $uuid: String!,
        $type: Int!,
        $payload: String!
        ) {
    createPaidLease(input:{
        uuidApp: $uuid,
        type: $type,
        payload: $payload
    }) {
        __typename
        uuids
        type
        created
        expires
        endpointsCompleted
        completed
    }
}
`;
